<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useQuizterStore } from '../../stores/quizterStore';
import Card from '../../components/Card.vue';
import QuestionProgressIndicator from '../../components/QuestionProgressIndicator.vue';
import NextButton from '../../components/NextButton.vue';
import useLocale from '../../../composables/use-locale';
import { useDisplay } from 'vuetify';
import QuestionPhrase from '../../components/QuestionPhrase.vue';

const quizterStore = useQuizterStore();
const { currentQuestion, currentQuestionIndex, numberOfQuestions, isLoading } = storeToRefs(quizterStore);

const { t } = useLocale();
const { smAndUp } = useDisplay();
</script>

<template>
  <div class="d-flex flex-column align-center ga-6">
    <div class="d-flex gc-4">
      <QuestionProgressIndicator
        v-if="smAndUp"
        class="my-2"
        :totalQuestions="numberOfQuestions!"
        :completedQuestions="currentQuestionIndex + 2"
      ></QuestionProgressIndicator>
      <Card v-if="currentQuestion" :content-max-width="800">
        <Transition name="fade" mode="out-in">
          <QuestionPhrase :current-question="currentQuestion" :host="true" />
        </Transition>
      </Card>
    </div>
    <NextButton
      :loading="isLoading"
      @click="quizterStore.nextQuestion"
      data-testid="quizter-show-answer-options-button"
    >
      {{ t('button_go_to_question_options') }}
    </NextButton>
  </div>
</template>
